import React, { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './Modal.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const cx = classNames.bind(styles);

function Modal({ isOpen, title, message, onConfirm, onCancel }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      await onConfirm(); // Gọi hàm onConfirm, giả định nó trả về Promise
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={cx('modal-overlay')}>
      <div className={cx('modal')}>
        <h2 className={cx('modal-title')}>{title}</h2>
        <p className={cx('modal-message')}>{message}</p>
        <div className={cx('modal-actions')}>
          <button
            className={cx('modal-button', 'confirm')}
            onClick={handleConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <FontAwesomeIcon icon={faSpinner} spin />
                <span>Đang gửi...</span>
              </>
            ) : (
              'Xác Nhận'
            )}
          </button>
          <button
            className={cx('modal-button', 'cancel')}
            onClick={onCancel}
            disabled={isSubmitting}
          >
            Hủy
          </button>
        </div>
      </div>
    </div>
  );
}

export default Modal;